/* DON'T EDIT THIS FILE: edit original and run build again */ export const canEditLineSharings = "canEditLineSharings";
export const canViewGrantedLineSharings = "canViewGrantedLineSharings";
// of course, only in the same counterparty/tenant
export const canAccessOtherUsersLineSharings =
  "canAccessOtherUsersLineSharings";
export const canAccessOtherProducersLineSharings =
  "canAccessOtherProducersLineSharings";
